var _path, _rect;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPinGreen(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 20,
    viewBox: "0 0 17 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.98293 7.09993C6.44729 4.26994 10.5447 4.42148 11.796 7.35192C12.2413 8.39469 12.1934 9.58253 11.6656 10.5861L8.30982 16.967L4.96244 10.7795C4.36021 9.66629 4.3479 8.32719 4.92955 7.20309L4.98293 7.09993Z",
    fill: "#AEFF03"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 3.9834,
    y: 17.967,
    width: 9,
    height: 2,
    fill: "#AEFF03"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPinGreen);
export default __webpack_public_path__ + "static/media/pin-green.07b0ae5eda0b91cc9d8acbc3e9d516a2.svg";
export { ForwardRef as ReactComponent };